import asyncScriptLoader from "@godweb/frontend-base/src/libs/tools/AsyncScriptsLoader";

export default function loadKit(params_to_add) {
  const config = window.getKitConfig(params_to_add);
  if (!config) {
    return;
  }
  config.config();
  asyncScriptLoader(config.url);
}
